import { Cohort } from 'root-constants'

import {
  CANCEL_OFFER_ADDITIONAL_DISCOUNT,
  DEFAULT_DYNAMIC_DISCOUNT,
} from '../constants'

export const getDynamicCohortDiscountPercentage = ({
  isCancelOfferRoute,
  dynamicDiscountAmount,
}: {
  cohort: Cohort
  isCancelOfferRoute: boolean
  dynamicDiscountAmount?: number
}) => {
  const baseDiscountPercentage =
    dynamicDiscountAmount || DEFAULT_DYNAMIC_DISCOUNT
  const appliedDiscount = isCancelOfferRoute
    ? baseDiscountPercentage + CANCEL_OFFER_ADDITIONAL_DISCOUNT
    : baseDiscountPercentage

  return appliedDiscount
}
